import { style, styleVariants } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'
import { AlertVariation } from './AlertVariation'

const alertPadding = 16

export const alertBase = style({
  display: 'flex',
  position: 'relative',
  padding: alertPadding,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  alignItems: 'flex-start',
  marginBottom: 16,
  gap: 16,
  gridColumn: '1 / -1',

  selectors: {
    '&:not(:first-child)': {
      marginTop: 16
    },
    '&:last-child': {
      marginBottom: 0
    }
  }
})

export const alertIcon = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: '1 / 1',
  fontSize: 20,
  flex: '0 0 38px',
  borderRadius: vars.buttons.radius,
  color: vars.color.white,
  background: vars.color.dark
})

export const alertMain = style({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  flex: 1,
  gap: 4
})

export const alertMainTitle = style({
  paddingRight: alertPadding * 2 + 16
})

export const alertClose = style({
  position: 'absolute',
  top: alertPadding,
  right: alertPadding,
  background: 'none',
  border: 'none',
  marginLeft: 'auto',
  cursor: 'pointer',
  transition: 'opacity 0.2s',

  ':hover': {
    opacity: 0.8
  }
})

export const alertLink = style({
  fontSize: vars.font.smallNormal.size,

  selectors: {
    [`${alertBase} &:not(:first-child):before`]: {
      content: '',
      textDecoration: 'none',
      margin: '0 4px'
    }
  }
})

export const alertIconVariations = styleVariants({
  [AlertVariation.Primary]: {
    background: vars.color.dark
  },
  [AlertVariation.Secondary]: {
    background: vars.color.white
  },
  [AlertVariation.Danger]: {
    background: vars.color.danger
  },
  [AlertVariation.Warning]: {
    background: vars.color.warning
  },
  [AlertVariation.Success]: {
    background: vars.color.success
  },
  [AlertVariation.Info]: {
    background: vars.color.dark
  }
})

export const alertCloseVariations = styleVariants({
  [AlertVariation.Primary]: {
    color: vars.color.white
  },
  [AlertVariation.Secondary]: {
    color: vars.color.white
  },
  [AlertVariation.Danger]: {
    color: vars.color.danger
  },
  [AlertVariation.Warning]: {
    color: vars.color.warning
  },
  [AlertVariation.Success]: {
    color: vars.color.success
  },
  [AlertVariation.Info]: {
    color: vars.color.dark
  }
})

export const alertVariations = styleVariants({
  [AlertVariation.Primary]: {
    background: vars.color.dark,
    color: vars.color.white
  },
  [AlertVariation.Secondary]: {
    background: vars.color.white
  },
  [AlertVariation.Danger]: {
    background: vars.color.dangerLighter
  },
  [AlertVariation.Warning]: {
    background: vars.color.warningLighter
  },
  [AlertVariation.Success]: {
    background: vars.color.successLighter
  },
  [AlertVariation.Info]: {
    background: vars.color.mediumLighter
  }
})
